import { FC, ReactNode } from 'react';

import { FormattedMessage } from '../../Intl';

export type PaginationSummaryEntriesProps = {
  page?: number;
  itemsPerPage?: number;
  totalItems: number;
};

export const PaginationSummaryEntries: FC<PaginationSummaryEntriesProps> = ({ page, itemsPerPage, totalItems }) => {
  function renderPaginationEntries(page?: number, itemsPerPage?: number, totalItems?: number): ReactNode {
    if (page && itemsPerPage) {
      const firstDisplayedItemIndex: number = (page - 1) * itemsPerPage + 1;
      const lastDisplayedItemIndex: number = page * itemsPerPage;
      return (
        <FormattedMessage
          id="blotter.pagination.showingSentence"
          values={{ firstIndex: firstDisplayedItemIndex, lastIndex: lastDisplayedItemIndex, total: totalItems }}
        >
          {text => <span className="from-to">{text}</span>}
        </FormattedMessage>
      );
    } else {
      return (
        <FormattedMessage id="blotter.pagination.showingTotalSentence" values={{ total: totalItems }}>
          {text => <span className="from-to">{text}</span>}
        </FormattedMessage>
      );
    }
  }

  return <span>{renderPaginationEntries(page, itemsPerPage, totalItems)}</span>;
};

PaginationSummaryEntries.displayName = 'PaginationSummaryEntries';
